import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Player from '../../components/Player'
import './index.scss'
import greaterIcon from '../../assets/images/greater__symbol.svg'
import { useParams } from "react-router";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { toast } from "react-toastify";
import initialQuery, { queryNFT, viewNFT } from "../../services/contracts";
import { string } from "prop-types";
import { Modal, Button } from 'antd';
import { mintNftTransaction } from "../../services/contractWrite";
import processingGIF from '../../assets/images/rocket.gif'
import logo from '../../assets/images/comdexCertificateLogo.svg'


const Module = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.module.list);
  const current = useSelector((state) => state.module._);
  const lesson = useSelector((state) => state.module.lesson);
  const userAdd = useSelector((state) => state.module.userAdd);
  const { id } = useParams();
  const [userAddress, setUserAddress] = useState();
  const userWatchedVideo = useSelector((state) => state.module.userWatchedVideo)
  const processing = useSelector((state) => state.module.processing)

  const moduleComplete = useSelector((state) => state.module.moduleComplete);
  const [isLoading, setIsLoading] = useState(false)
  const [progress, setProgress] = useState(false)

  let currentModule = current.id;
  let currentVideo = current['lessons'] && current['lessons'][lesson.index].index + 1;
  let currentModuleName = current.title;

  const [nftData, setEnableMintBtn] = useState(false);
  const [showMintBtn, setShowMintBtn] = useState(true)
  const [disableBtn, setDisableBtn] = useState(true);
  const [userNFTid, setUserNFTId] = useState("");
  const [userNFTData, setUserNFTData] = useState({
    address: "",
    modulename: "",
    date: ""
  })

  const [isModalVisible, setIsModalVisible] = useState(false);



  const showModal = () => {
    setIsModalVisible(true);
    queryNFT(current?.id).then((res) => {
      console.log("This is nft res", res);
      if (res === "None") {
      }
      if (res !== "None") {
        setUserNFTId(res)
        setShowMintBtn(false)
        viewNFT(res).then((res) => {
          setUserNFTData({ ...userNFTData, address: res.owner, modulename: res.module_completed, date: res.date_completed })
        });
      }

    })
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const mint = () => {
    dispatch({ type: "SET_PROCESSING", value: true })
    setProgress(true)
    toast.info(
      <span className='toast'>Transaction Initiated</span>,
      {
        position: "bottom-center",
      }
    );

    mintNftTransaction(currentModule, currentModuleName, (error, result) => {
      if (error) {
        console.log(error);
        setIsLoading(false);
        setProgress(false)
        dispatch({ type: "SET_PROCESSING", value: false })

        toast.error(
          <span className='toast'>Transaction Failed</span>,
          {
            position: "bottom-center",
          }
        );
        return;
      }
      setIsLoading(false);
      setProgress(false)



      toast.success(
        <span className='toast'>Transaction Successful</span>,
        {
          position: "bottom-center",
        }
      );
      if (result) {

        setShowMintBtn(false)
      }

    });
  }




  useEffect(() => {
    // console.log("useeffect 1");
    dispatch({ type: "USER_WATCHED_VIDEO", value: [] })

    let userAddress = localStorage.getItem('ac');
    setUserAddress(userAddress);
    window.scrollTo(0, 0);
    if (id && !current.id) {
      dispatch({ type: "CURRENT_MODULE_SET", value: data[id - 1] });
      dispatch({ type: "CURRENT_LESSON_SET", value: data[id - 1] && data[id - 1].lessons && data[id - 1].lessons[0] });
    }
    if (current.id && !lesson) {
      dispatch({ type: "CURRENT_LESSON_SET", value: current && current.lessons && current.lessons[0] });
    }
  }, [current]);


  useEffect(() => {
    // console.log("useeffect 2");
    let userAddress = localStorage.getItem('ac');
    setUserAddress(userAddress);
    queryNFT(current?.id).then((res) => {
      // console.log("This is nft res", res);
      if (res === "None") {
      }
      if (res !== "None") {
        setUserNFTId(res)
        setShowMintBtn(false)
        viewNFT(res).then((res) => {
          setUserNFTData({ ...userNFTData, address: res.owner, modulename: res.module_completed, date: res.date_completed })
        });
      }

    })
    if (userAddress) {

      initialQuery(current?.id).then((res) => {
        // console.log(res);
        dispatch({ type: "USER_WATCHED_VIDEO", value: res })
        if (res.length === current?.lessons?.length) {
          setDisableBtn(false);
        }
      })
    }
  }, [lesson, current, userWatchedVideo])
  // userWatchedVideo put in this dependency


  return (
    <>
      <section>
        <div className="module-main-container" >
          <div className="container">
            <div className="module-container">
              <div className="back-button">
                <Link to="/courseModule">&larr; Back</Link>
              </div>
              <div className="module-name">{current?.module}</div>
              <div className="module-arrow"><img src={greaterIcon} alt="greater-icon" /></div>
              <div className="module-title">{current?.title}</div>
            </div>
          </div>
        </div>
        <div className="course-main-container">
          <div className="container">
            <div className="course-container">
              <div className="video-container">
                <div className="video-player">
                  <Player />
                </div>
              </div>
              <div className="playlist-container ">
                <div className="playlist">
                  {current && current.lessons && current.lessons.length > 0 ? current.lessons.map((item, index) => {
                    return (
                      <div className="playlist-lesson-container"
                        key={index}
                        onClick={() => {
                          dispatch({ type: "CURRENT_LESSON_SET", value: item });
                        }}
                      >
                        <div className="left">
                          <div className="lesson-name"><div className="btn-primary">{item.title}</div> </div>
                          <div className="lesson-title">{item.description}</div>
                          <div className="lesson-time">{item.duration}</div>
                          <hr />
                        </div>
                        <div className="right">
                          <div className="lesson-checkbox"><input type="checkbox" readOnly={true} checked={userWatchedVideo.includes(String(index + 1))} /></div>
                        </div>
                      </div>
                    );
                  }) : <div >No data</div>}
                </div>
              </div>
              <div className="description-container" >
                <div className="description-main">
                  <div className="lesson">
                    <div className="btn-primary">{lesson && lesson.title}</div>
                  </div>
                  <div className="title">{lesson && lesson.description}</div>
                  <div className="description-box">
                    <div className="description-name">Description</div>
                    <div className="decsription-text">
                      {lesson && lesson.videoDescription}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {isLoading && (
            <>
              <div className="loading_main_container">
                <div className="loading_container">
                  <div className="content_container">
                    <div className="loader">
                      <img src={processingGIF} alt="Processing" />
                    </div>
                    <div className="text">Transaction in Process</div>
                  </div>
                  <div className="cut_btn"></div>
                </div>
              </div>
            </>
          )}

        </div>
      </section>
    </>
  );
};

export default Module;
